import React, { useState } from "react";
import { Alert, Button, Input, ListGroup, ListGroupItem, Spinner } from "reactstrap";

import { apiFetch, API } from "../../services/api";
import { readError } from "../../helpers/whatsappTemplates";

// Client Qonto des devis et factures de réservations : recherche dans les clients existants, puis association.
export function QontoClientPicker({ value, name, onChange }) {
    const [q, setQ] = useState("");
    const [list, setList] = useState(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const search = async () => {
        setBusy(true);
        setError(null);
        const res = await apiFetch(`${API.back}/display-qonto-clients?q=${encodeURIComponent(q)}`, { market: false });
        setBusy(false);
        if (!res.ok) { setError(await readError(res)); return; }
        setList(await res.json());
    };

    return (
        <div>
            <div className="mb-2">Client associé : {value ? <b>{name || value}</b> : <span className="text-muted">aucun (devis impossibles)</span>}
                {value && <Button size="sm" color="link" onClick={() => onChange("", "")}>Dissocier</Button>}</div>
            <div className="d-flex">
                <Input bsSize="sm" placeholder="Rechercher un client Qonto (nom)" value={q} onChange={(e) => setQ(e.target.value)} className="mr-2"
                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); search(); } }} />
                <Button size="sm" onClick={search} disabled={busy || !q.trim()}>{busy ? <Spinner size="sm" /> : "Rechercher"}</Button>
            </div>
            {error && <Alert color="danger" className="py-1 mt-2">{error}</Alert>}
            {list && (
                <ListGroup className="mt-2">
                    {list.length === 0 && <ListGroupItem className="text-muted">Aucun client trouvé (secret Qonto non configuré ?)</ListGroupItem>}
                    {list.map((c) => (
                        <ListGroupItem key={c.id} action tag="button" type="button" onClick={() => { onChange(c.id, c.name); setList(null); }}>
                            <b>{c.name}</b> <span className="small text-muted">{[c.vatNumber, c.address?.city].filter(Boolean).join(" · ")}</span>
                        </ListGroupItem>
                    ))}
                </ListGroup>
            )}
        </div>
    );
}
